import Vue from 'vue';
import Intro1 from '@/components/intros/Intro1.vue';
import Intro2 from '@/components/intros/Intro2.vue';
import Intro3 from '@/components/intros/Intro3.vue';
import Intro4 from '@/components/intros/Intro4.vue';
import Intro5 from '@/components/intros/Intro5.vue';
import DOD_Intro1 from '@/components/intros/DOD_Intro1.vue';
import DOD_Intro2 from '@/components/intros/DOD_Intro2.vue';
import DOD_Intro3 from '@/components/intros/DOD_Intro3.vue';
import DOD_Intro4 from '@/components/intros/DOD_Intro4.vue';
import DOD_Intro5 from '@/components/intros/DOD_Intro5.vue';

Vue.component('wes-i1', Intro1);
Vue.component('wes-i2', Intro2);
Vue.component('wes-i3', Intro3);
Vue.component('wes-i4', Intro4);
Vue.component('wes-i5', Intro5);
Vue.component('wes-DOD-i1', DOD_Intro1);
Vue.component('wes-DOD-i2', DOD_Intro2);
Vue.component('wes-DOD-i3', DOD_Intro3);
Vue.component('wes-DOD-i4', DOD_Intro4);
Vue.component('wes-DOD-i5', DOD_Intro5);
